export const SET_TRENDING_SESSIONS = "landing/set-trending-sessions";
export const RESET = "landing/reset";
